<template>
    <div v-if="isShow" class="l-award-body">
        <div class="l-award-main">
            <img class="l-award-top" src="./images/background.png" alt="" />
            <div class="l-award-title">
                <div class="txt">恭喜你，在本次战报上传中获得<span>「{{ opsions.score }}」</span>，快来领取奖励吧！</div>
                <div class="cion">
                    <img src="./images/l-coin.png" alt="" />
                    <span>x{{ opsions.amount }}</span>
                </div>
            </div>
            <img class="l-award-button" src="./images/button.png" @click="handleReportPrize" />
        </div>
    </div>
</template>
<script>
import TaskModel from "./../../../models/task"
const taskModel = new TaskModel()
export default {
    components: {

    },
    props: {
        opsions: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    watch: {
        opsions: {
            handler: function (val) {
                if (val.receiveReward == 0) {
                    this.isShow = true
                }
            },
            deep: true
        },
    },
    mounted() {
    },
    data() {
        return {
            isShow: false,
            currencyData: {

            },
        }
    },
    methods: {
        handleClose() {
            this.isShow = false
        },
        handleReportPrize() {
            taskModel.postReportPrize({ taskId: this.opsions.taskId }).then(res => {
                if (res.status === 0&&res.data) {
                    this.isShow = false
                }
            })
        }
    }


}
</script>
<style scoped lang="stylus">
@import "./index.styl"
</style>